import React, { useEffect, useState } from 'react';
import Footer from '../../components/footer';
import { Otherwise, Choose, When } from 'babel-plugin-jsx-control-statements';
import { Pulse, DEVICES, NavigationHelpers, NetworkHelper, getCurrentEnv } from 'common-utilities';
import { EVENT_CATEGORY, PAYTM_CARE_URL } from '../../constants';
import { useDeviceType } from 'common-utilities';
import OutlinedButton from '../../components/outlineButton';
import PaytmLogo from '../../assets/paytmSheild.svg';
import CallIcon from '../../assets/callIcon.svg';
import CallIconWhite from '../../assets/callIconWhite.svg';
import './style.scss';
import MobileFooter from '../../components/mobileFooter';
import { fetchPropertyConfig } from 'common-utilities';

const ENV = getCurrentEnv();
function Error(props) {
	const Device = useDeviceType();
	const [reportFraudIvr, setReportFraudIvr] = useState('');
	const setConfigData = async () => {
		setReportFraudIvr(await fetchPropertyConfig('fraud_detection_ivr_number'));
	};
	useEffect(() => {
		setTimeout(() => {
			Pulse.push({
				event_action: 'link_expired_screen_loaded',
				event_category: EVENT_CATEGORY,
				screenName: '/unblock_otp_error'
			});
		});
		setConfigData();
	}, []);
	return (
		<React.Fragment>
			<div className="errorPageContainer">
				<div className="imageContainer">
					<img src={PaytmLogo} alt="paytm-icon" />
				</div>
				<div className="heading">Page Expired</div>
				<div className="text-container">
					This link is no longer active. Please call Paytm security to report.
				</div>
				<Choose>
					<When condition={Device === DEVICES.DESKTOP}>
						<a className="callButtonDesktop" href={`tel:${reportFraudIvr}`}>
							<img src={CallIcon} alt="call-icon" />
							<span>{reportFraudIvr}</span>
						</a>
						<div className="buttonContainer">
							<OutlinedButton
								onClick={() => {
									Pulse.push({
										event_action: 'need_help_clicked',
										event_category: EVENT_CATEGORY,
										screenName: '/report_fraud_error'
									});
									NavigationHelpers.redirectToPaytm(PAYTM_CARE_URL);
								}}
								oauth-id="need_help_btn"
							>
								<div className="buttonText">Need Help?</div>
							</OutlinedButton>
						</div>
					</When>
					<Otherwise>
						<a className="primary-button callButton" href={`tel:${reportFraudIvr}`}>
							<img src={CallIconWhite} alt="call-icon" />
							<span>{reportFraudIvr}</span>
						</a>
					</Otherwise>
				</Choose>
			</div>
			<Choose>
				<When condition={Device === DEVICES.DESKTOP}>
					<Footer />
				</When>
				<Otherwise>
					<MobileFooter
						onClick={() => {
							Pulse.push({
								event_action: 'need_help_clicked',
								event_category: EVENT_CATEGORY,
								screenName: '/report_fraud_error'
							});
							NavigationHelpers.redirectToPaytm(PAYTM_CARE_URL);
						}}
						oauth-id="need-help-btn"
					>
						Need Help?
					</MobileFooter>
				</Otherwise>
			</Choose>
		</React.Fragment>
	);
}
export default Error;
